// Guías de Aprender · Reglas (2026-10-18). Cada regla se explicó con el motor del juego delante
// (backend/ai-engine: alturas, dominación, captura, entrada de bloques) y con el libro.

export const OFFICIAL_RULES_ES = [
  "Al comenzar, cada jugador tiene sus 10 bloques (9 comunes y 1 especial) fuera del tablero.",
  "Cada jugador mueve una vez por turno y puede incorporar o subir un bloque por cualquiera de las cuatro caras de la pirámide.",
  "En su turno, el jugador elige entre incorporar un bloque nuevo o mover uno de los que ya tiene en el tablero.",
  "Los bloques se mueven en línea recta en cualquier dirección (horizontal, vertical o diagonal), tantos pasos como se quiera o, en los modos con azar, los pasos que indiquen los dados.",
  "Al incorporar un bloque, su primer y su último paso deben ser sobre el tablero: no puede empezar ni terminar encima de otro bloque.",
  "Una vez dentro, un bloque no puede salir del tablero.",
  "En cada paso, un bloque puede subir a un lugar que tenga como máximo su misma altura, y puede bajar a cualquier lugar más bajo.",
  "Si un bloque termina su movimiento encima de otro u otros, los domina: los de abajo no pueden moverse. Además elimina a los bloques de otro color que queden en minoría en esa columna.",
  "Un bloque especial no puede subir ni pasar por encima de otro bloque especial.",
  "Si a un jugador le capturan el bloque especial, puede llevar un bloque común a la cima para rescatarlo. Después podrá incorporar el especial de nuevo cuando quiera.",
  "Un bloque común no puede terminar en la cima salvo para rescatar al especial, aunque sí puede pasar por encima de la casilla G7.",
  "Si un jugador, en su turno, no tiene bloques dentro ni fuera del tablero, pierde la partida (sin recurso).",
  "Si un jugador, en su turno, no tiene bloques fuera del tablero para incorporar y todos sus bloques en el tablero están dominados, gana la partida (ahogado).",
  "No se puede repetir por tercera vez consecutiva la misma posición o la misma secuencia de movimientos.",
  "Ante cualquier situación de empate o estancamiento se pide siempre incremento de material, nunca tablas.",
  "El incremento de material es de tres bloques comunes extra para cada jugador.",
];

export const REGLAS_GUIDES = [
  {
    slug: "reglas",
    theme: "reglas",
    nav: "Reglas de XIMA",
    title: "Reglas de XIMA: las 16 reglas oficiales explicadas",
    description:
      "Las reglas oficiales de XIMA explicadas con ejemplos: turnos, incorporar, mover en línea recta, subir de piso, dominar, capturar, rescatar y ganar.",
    h1: "Reglas de XIMA",
    intro:
      "XIMA tiene 16 reglas oficiales. Aquí están todas, agrupadas por tema y explicadas con ejemplos. Si es tu primera vez, empieza por Cómo jugar y vuelve aquí cuando tengas una duda.",
    sections: [
      {
        h: "El objetivo",
        p: [
          "Llevar tu bloque especial a la cima del tablero, la casilla G7, con una jugada legal. Quien lo consigue primero gana la partida.",
        ],
      },
      {
        h: "Inicio y turnos (reglas 1 a 3)",
        p: [
          "Cada jugador empieza con sus 10 bloques fuera del tablero: 9 comunes y 1 especial. Se juega por turnos y en cada turno haces un solo movimiento: incorporar un bloque nuevo o mover uno que ya está dentro. Puedes entrar o subir por cualquiera de las cuatro caras de la pirámide.",
        ],
      },
      {
        h: "Cómo se mueven los bloques (reglas 4 a 7)",
        p: [
          "Todos los bloques se mueven igual: en línea recta, en cualquiera de las ocho direcciones (horizontal, vertical o diagonal). En Modo Ciencia avanzas los pasos que quieras; en los modos con azar, los que marquen los dados.",
          "Para incorporar un bloque, entras por el borde de la pirámide: el primer paso y el último tienen que ser sobre el tablero, nunca encima de otro bloque. Una vez dentro, un bloque ya no puede salir.",
          "La regla de la altura es la clave del juego: en cada paso un bloque puede subir, como mucho, hasta su propia altura (la de un bloque), y puede bajar todo lo que quiera. Como cada piso está dos alturas por encima del anterior, para subir de piso necesitas pasar por encima de otro bloque que te sirva de escalón.",
        ],
        figure: "tablero-vista-lateral",
      },
      {
        h: "Dominar y capturar (regla 8)",
        p: [
          "Si terminas tu movimiento encima de uno o varios bloques, los dominas: no se pueden mover mientras estés encima. Y si, con tu llegada, tu color es el que más bloques tiene en esa columna, todos los bloques de los colores que tengan menos se capturan y salen del juego.",
          "Ejemplo: un bloque azul domina a uno rojo (1 contra 1: el rojo no se mueve, pero sigue en juego). Si llega un segundo azul a esa columna (bajando desde más alto), los azules son mayoría y el rojo se captura.",
        ],
        figure: "dominacion-captura",
      },
      {
        h: "El bloque especial (reglas 9 a 11)",
        p: [
          "El especial no puede subir ni pasar por encima del especial contrario. Si te lo capturan, puedes rescatarlo llevando un bloque común a la cima; a cambio recuperas tu especial y lo vuelves a meter cuando quieras. Fuera de ese caso, un bloque común nunca puede terminar en la cima, aunque sí puede pasar por encima de ella.",
        ],
      },
      {
        h: "Cómo termina la partida (reglas 12 y 13)",
        list: [
          "Gana quien lleva su especial a la cima.",
          "Gana el jugador ahogado: el que, en su turno, no tiene bloques fuera para incorporar y tiene todos sus bloques del tablero dominados.",
          "Pierde quien, en su turno, no tiene ningún bloque ni dentro ni fuera del tablero (sin recurso).",
          "También termina si un jugador abandona o se queda sin tiempo.",
        ],
      },
      {
        h: "Sin empates (reglas 14 a 16)",
        p: [
          "No se puede repetir por tercera vez seguida la misma posición o la misma secuencia de movimientos. Y si la partida se estanca, no hay tablas: se pide incremento de material y cada jugador recibe tres bloques comunes más.",
        ],
      },
    ],
    rulesList: true,
    faqs: [
      ["¿Cuántas reglas tiene XIMA?", "16 reglas oficiales. Además, el libro «Cómo llegar a la Xima» explica casos especiales como el ahogado, la posición muerta o el rescate."],
      ["¿Se puede mover en curva?", "No. Cada movimiento es en línea recta y en una sola dirección. En Modo Azar sí puedes usar cada dado en una dirección distinta, porque cada dado es un movimiento."],
      ["¿Un bloque común puede ganar?", "No. Solo el bloque especial gana al llegar a la cima. Un común solo puede terminar en la cima para rescatar a tu especial capturado."],
      ["¿Qué pasa si no puedo mover ningún bloque?", "Si no te quedan bloques fuera para incorporar y todos los tuyos están dominados, estás ahogado y ganas la partida."],
    ],
    related: [
      "reglas/tablero-y-casillas",
      "reglas/subir-bloques",
      "reglas/dominacion-y-captura",
      "reglas/fin-de-partida",
      "reglas/rescate",
    ],
    cta: { label: "Cómo se sube de piso", slug: "reglas/subir-bloques" },
    legacy: ["reglas/jugada-legal", "reglas/turnos"],
    en: "en/rules",
  },
  {
    slug: "reglas/tablero-y-casillas",
    theme: "reglas",
    nav: "El tablero y las casillas",
    title: "El tablero de XIMA: pisos, casillas y coordenadas",
    description:
      "Cómo es el tablero de XIMA: pirámide de 4 pisos, 13 × 13 casillas, coordenadas de A1 a M13, anillos, bandas, caras, esquinas y la cima en G7.",
    h1: "El tablero y las casillas",
    intro:
      "El tablero de XIMA es una pirámide escalonada. Entender sus pisos y cómo se nombra cada casilla te permite leer cualquier partida, seguir la notación y planear tus caminos hacia la cima.",
    sections: [
      {
        h: "Visto desde arriba: 13 × 13 casillas",
        p: [
          "Mirado desde arriba, el tablero es un cuadrado de 13 columnas por 13 filas: 169 casillas. Las columnas se nombran con letras mayúsculas de la A a la M y las filas con números del 1 al 13. Así, cada casilla tiene un nombre: A1 es una esquina, M13 la esquina opuesta y G7, el centro, es la cima.",
        ],
        figure: "tablero-vista-superior",
      },
      {
        h: "Visto de lado: cuatro pisos",
        p: [
          "Cada piso forma un anillo de dos casillas de ancho alrededor del siguiente:",
        ],
        table: {
          head: ["Piso", "Zona (vista superior)", "Casillas"],
          rows: [
            ["1.º piso", "Las dos filas y columnas del borde (de A1 a M13 sin el cuadrado C3-K11)", "88"],
            ["2.º piso", "Cuadrado C3-K11 sin el cuadrado E5-I9", "56"],
            ["3.º piso", "Cuadrado E5-I9 sin la cima", "24"],
            ["4.º piso o cima", "Solo G7", "1"],
          ],
        },
        after: [
          "Cada piso está dos alturas de bloque por encima del anterior. Por eso no se puede pasar de un piso al siguiente sin apoyarse en otro bloque: hace falta un escalón.",
        ],
        figure: "tablero-vista-lateral",
      },
      {
        h: "Anillos: exterior e interior",
        p: [
          "Cada piso, menos la cima, tiene dos anillos. El anillo exterior es la fila de casillas del borde del piso; el anillo interior es la fila pegada al piso de arriba. En el primer piso, por ejemplo, A1 está en el anillo exterior y B2 en el interior.",
          "Las casillas del anillo interior son las más importantes para subir: un bloque colocado ahí hace de escalón para que otro pase al piso superior.",
        ],
      },
      {
        h: "Caras, bandas y esquinas",
        p: [
          "La pirámide tiene cuatro caras: A1-M1-G7, M1-M13-G7, M13-A13-G7 y A13-A1-G7. En una partida de dos jugadores, cada uno se sienta frente a una cara.",
          "Una banda son las dos hileras (exterior e interior) de una misma cara en un piso. Las esquinas exteriores son A1, M1, M13 y A13, y las interiores B2, L2, L12 y B12.",
          "Las centrales son las casillas de las líneas G1-G13 y A7-M7; las centrales exteriores son G1, M7, G13 y A7. Las diagonales superiores son las casillas de las diagonales A1-M13 y M1-A13: son el camino más corto hacia la cima, pero también el más fácil de bloquear.",
        ],
        figure: "caras-y-casillas",
      },
      {
        h: "La cima",
        p: [
          "G7 es la única casilla del cuarto piso. Solo el bloque especial puede terminar ahí para ganar; un bloque común solo puede hacerlo para rescatar al especial capturado, aunque cualquiera puede pasar por encima de G7 durante un movimiento.",
        ],
      },
    ],
    faqs: [
      ["¿Cuántas casillas tiene el tablero de XIMA?", "169 vistas desde arriba (13 × 13): 88 en el primer piso, 56 en el segundo, 24 en el tercero y 1 en la cima."],
      ["¿Cómo se llaman las casillas?", "Con una letra de columna (A a M) y un número de fila (1 a 13), como en el ajedrez pero con mayúsculas: A1, G7, M13…"],
      ["¿Dónde está la cima?", "En G7, el centro exacto del tablero, en el cuarto piso."],
      ["¿Qué es una casilla interior?", "Una casilla del anillo pegado al piso de arriba. Es donde se ponen los escalones para subir."],
    ],
    related: ["reglas/subir-bloques", "sistema-de-anotacion", "reglas/cima", "estrategia/aperturas-xima"],
    cta: { label: "Cómo se sube de piso", slug: "reglas/subir-bloques" },
    legacy: [
      "reglas/coordenadas",
      "tablero/pisos-anillos-bandas",
      "tablero/esquinas-y-caras",
      "tablero/g7-y-simbolos-de-cima",
    ],
    en: "en/board",
  },
  {
    slug: "reglas/bloques",
    theme: "reglas",
    nav: "Bloques comunes y especial",
    title: "Bloques de XIMA: el bloque especial y los comunes",
    description:
      "Cada jugador de XIMA tiene 10 bloques: 9 comunes y 1 especial. Qué puede hacer cada uno, por qué el especial es la pieza clave y cuándo conviene meterlo.",
    h1: "Bloques comunes y bloque especial",
    intro:
      "En XIMA todas las piezas se llaman bloques y todas se mueven igual. Cada jugador tiene diez: nueve comunes y uno especial. La diferencia está en lo que cada uno puede conseguir.",
    sections: [
      {
        h: "Los bloques comunes",
        p: [
          "Son tus obreros. Con ellos construyes los caminos hacia arriba, haces de escalón, dominas y capturas bloques rivales, bloqueas el paso del contrario y, si te capturan el especial, lo rescatas.",
          "Un bloque común nunca gana por llegar a la cima. Solo puede terminar en G7 para rescatar a tu especial capturado, aunque sí puede pasar por encima de la cima en mitad de un movimiento.",
        ],
      },
      {
        h: "El bloque especial",
        p: [
          "Es el único que gana al llegar a la cima, y por eso el libro de XIMA lo llama «el alma de la estrategia». Se mueve igual que los demás, pero tiene tres rasgos únicos:",
        ],
        list: [
          "No puede subir ni pasar por encima del especial contrario. Dos especiales nunca pueden estar en la misma columna.",
          "Es el único bloque que puede volver al juego después de ser capturado, mediante el rescate.",
          "Gracias a esa primera regla, es el único que puede frenar el paso del especial rival (la oposición).",
        ],
      },
      {
        h: "¿Cuándo meter el especial?",
        p: [
          "El libro recomienda no incorporarlo al principio. Primero se prepara el camino con los comunes y el especial entra cuando ya puede subir rápido y seguro, idealmente en el segundo o tercer piso y por el anillo interior de la misma banda que el especial contrario. Como orientación, se aconseja meterlo como sexto, séptimo u octavo bloque.",
          "Mientras tanto, el especial es sobre todo defensivo. En el final de la partida se vuelve muy ofensivo, porque la oposición le permite cerrar el paso al especial rival.",
        ],
      },
      {
        h: "Dominar al especial rival sin capturarlo",
        p: [
          "A veces conviene dominar al especial contrario y no capturarlo todavía: dominado no se mueve, y si lo capturas el rival podría rescatarlo y volver a meterlo en una posición mejor.",
        ],
      },
      {
        h: "Colores y aspecto",
        p: [
          "Cada jugador tiene un color. En la Tienda y en Modo Diseñar puedes cambiar el aspecto de tus bloques con skins, pero eso es solo estético: no cambia ninguna regla.",
        ],
      },
    ],
    faqs: [
      ["¿Cuántos bloques tiene cada jugador?", "Diez: nueve comunes y uno especial. Con el incremento de material se añaden tres comunes más."],
      ["¿El bloque especial se mueve distinto?", "No. Se mueve igual que los comunes; lo que cambia es que gana en la cima y no puede pasar sobre el otro especial."],
      ["¿Un skin da ventaja?", "No. Los skins solo cambian el aspecto de los bloques."],
    ],
    related: ["reglas/oposicion-especial", "reglas/rescate", "reglas/cima", "reglas/amenazas-al-especial"],
    cta: { label: "La oposición del especial", slug: "reglas/oposicion-especial" },
    legacy: ["reglas/bloque-especial"],
  },
  {
    slug: "reglas/incorporar-bloque",
    theme: "reglas",
    nav: "Incorporar un bloque",
    title: "Incorporar un bloque en XIMA: cómo entrar al tablero",
    description:
      "Cómo se mete un bloque en el tablero de XIMA: por qué borde se entra, en qué direcciones, cuántos pasos y por qué no puedes entrar encima de otro bloque.",
    h1: "Incorporar un bloque",
    intro:
      "Incorporar es meter en el tablero uno de los bloques que tienes fuera. Es lo que harás en tus primeros turnos y, más adelante, la forma de sorprender al rival con un bloque nuevo.",
    sections: [
      {
        h: "Por dónde se entra",
        p: [
          "Se entra siempre por el borde de la pirámide, es decir, por una casilla del anillo exterior del primer piso (las filas 1 y 13 y las columnas A y M). Puedes elegir cualquiera de las cuatro caras.",
          "Desde esa casilla del borde el bloque puede quedarse ahí o seguir avanzando en línea recta hacia dentro: de frente o en diagonal, a la derecha o a la izquierda. No se puede entrar de lado, recorriendo el borde.",
        ],
        figure: "incorporar-bloque",
      },
      {
        h: "La regla del primer y el último paso",
        p: [
          "Al incorporar, el primer paso (la casilla del borde por la que entras) y el último (donde terminas) tienen que ser sobre el tablero, no sobre otro bloque, ni siquiera tuyo. Por eso no se puede dominar ni capturar en el mismo movimiento en que se entra.",
          "La razón es sencilla: si se pudiera entrar encima de otro bloque, el segundo jugador taparía cada bloque que el primero metiera y el juego no funcionaría.",
          "En el camino sí puedes pasar por encima de otros bloques, siempre que respetes la regla de la altura. Así, un bloque que entra por A1 puede pasar sobre un bloque tuyo en B2 y terminar en C3, ya en el segundo piso.",
        ],
      },
      {
        h: "Cuántos pasos",
        p: [
          "En Modo Ciencia avanzas los pasos que quieras. En Modo Azar, la casilla del borde cuenta como el primer paso: con un 4 en el dado entras por el borde y avanzas tres casillas más. Por ejemplo, entrar por A1 y subir en línea recta hasta A4 se anota «4/-A4».",
        ],
      },
      {
        h: "Consejos",
        list: [
          "En la apertura, el libro aconseja meter de 5 a 7 bloques antes de empezar a maniobrar.",
          "Guarda al menos un bloque común fuera para el final: entrar tarde, cuando el rival ya no tiene bloques fuera, puede darte varios tiempos de ventaja.",
          "No metas el especial hasta que pueda entrar alto y protegido.",
        ],
      },
    ],
    faqs: [
      ["¿Puedo entrar encima de un bloque?", "No. Al incorporar no puedes empezar ni terminar sobre otro bloque, aunque sí pasar por encima en el camino."],
      ["¿Un bloque puede entrar directamente al segundo piso?", "Sí, si en su camino hay un escalón: por ejemplo, de A1 a C3 pasando por encima de un bloque en B2."],
      ["¿Puedo sacar un bloque que ya entró?", "No. Una vez dentro, solo sale del tablero si lo capturan."],
    ],
    related: ["reglas/movimientos", "reglas/subir-bloques", "estrategia/aperturas-xima", "sistema-de-anotacion"],
    cta: { label: "Mover un bloque", slug: "reglas/movimientos" },
  },
  {
    slug: "reglas/movimientos",
    theme: "reglas",
    nav: "Mover un bloque",
    title: "Movimientos en XIMA: cómo se mueven los bloques",
    description:
      "En XIMA todos los bloques se mueven igual: en línea recta, en 8 direcciones y los pasos que quieras. Qué puede cortar un movimiento y cuándo una jugada es legal.",
    h1: "Mover un bloque",
    intro:
      "Una de las ventajas de XIMA es que no hay que aprender un movimiento distinto para cada pieza: todos los bloques se mueven igual. Esta guía explica cómo, y qué hace que una jugada sea legal o no.",
    sections: [
      {
        h: "En línea recta y en ocho direcciones",
        p: [
          "Un bloque se mueve en línea recta en cualquiera de las ocho direcciones: adelante, atrás, a los lados o en diagonal. En Modo Ciencia puede avanzar tantos pasos como quiera; el libro define un movimiento como un recorrido de 1 a 12 pasos en la misma dirección.",
          "Durante el movimiento no se puede cambiar de dirección. Además de avanzar por el plano, el bloque sube y baja de piso según la altura de lo que encuentra en el camino.",
        ],
      },
      {
        h: "Qué puede cortar un movimiento",
        list: [
          "El borde del tablero: ningún bloque puede salir de la pirámide.",
          "La altura: en cada paso solo se puede subir la altura de un bloque. Un muro de dos alturas (un piso superior sin escalón, o una torre de dos bloques) corta el camino.",
          "El especial contrario: tu especial no puede entrar en una casilla donde esté el especial rival, ni pasar por encima de ella.",
          "La cima: solo tu especial puede terminar en G7 (o un común, para rescatarlo).",
        ],
      },
      {
        h: "Mover desde una torre",
        p: [
          "Solo se mueve el bloque de arriba de una columna. Cuando lo mueves, liberas a los que tenía debajo. Un bloque que está encima de otro tiene más altura y por eso puede subir más lejos: es lo que se llama doblar columna.",
        ],
      },
      {
        h: "¿Por qué el juego no me deja mover?",
        list: [
          "No es tu turno, o en un modo con dados todavía no has lanzado.",
          "El bloque que tocas está dominado (tiene otro encima).",
          "El destino exige subir más de una altura de bloque en algún paso.",
          "En Modo Azar, el destino no está exactamente a los pasos que marca el dado.",
          "Intentas pasar con tu especial sobre el especial rival.",
          "Repetirías por tercera vez seguida la misma posición o secuencia.",
        ],
      },
    ],
    faqs: [
      ["¿Puede un bloque saltar por encima de otros?", "Sí. Pasa por encima de los bloques que encuentra, siempre que en cada paso no suba más de una altura de bloque. Si termina encima de uno, lo domina."],
      ["¿Se puede mover un bloque dominado?", "No. Solo se mueve el bloque de arriba de cada columna."],
      ["¿Cuántos movimientos hago por turno?", "Uno. En Modo Azar, cada uno de los dos dados es un movimiento, así que haces dos."],
    ],
    related: ["reglas/subir-bloques", "reglas/bloqueo-y-obstruccion", "reglas/dados", "reglas/dominacion-y-captura"],
    cta: { label: "Cómo se sube de piso", slug: "reglas/subir-bloques" },
    legacy: ["reglas/mover-bloque", "solucion/movimiento-no-permitido"],
  },
  {
    slug: "reglas/subir-bloques",
    theme: "reglas",
    nav: "Subir de piso",
    title: "Cómo subir de piso en XIMA: alturas y escalones",
    description:
      "La regla más importante de XIMA: cuánto sube un bloque en cada paso, por qué hace falta un escalón para cambiar de piso y cómo llegar al tercero.",
    h1: "Subir de piso",
    intro:
      "Ganar en XIMA es, sobre todo, subir antes que el rival. Para eso hay que entender una sola regla, la de la altura, y aprender a construir escalones.",
    sections: [
      {
        h: "La regla de la altura",
        p: [
          "En cada paso, un bloque puede subir, como mucho, hasta su misma altura: es decir, puede subirse a algo que tenga la altura de un bloque. Bajar, en cambio, puede bajar lo que quiera.",
          "Cada piso de la pirámide está dos alturas de bloque por encima del anterior. Por eso un bloque que está sobre el primer piso no puede pasar directamente al segundo: el escalón es demasiado alto. Necesita un apoyo intermedio.",
        ],
        figure: "tablero-vista-lateral",
      },
      {
        h: "El escalón",
        p: [
          "El apoyo es otro bloque colocado en una casilla interior, pegado al piso de arriba. El bloque que sube pasa por encima del escalón y, en el mismo movimiento, llega al piso superior.",
          "Ejemplo: tienes un bloque en A1 y otro en B2 (casilla interior del primer piso). El de A1 se mueve en diagonal: pasa por encima de B2 (sube una altura) y llega a C3 (sube otra altura y ya está en el segundo piso).",
          "El escalón puede ser tuyo o del rival. El libro distingue la escalera natural (el bloque que sube pasa por el escalón en un solo movimiento) de la escalera artificial (primero tiene que dominar el escalón y, en el turno siguiente, subir).",
        ],
        figure: "subir-con-escalon",
      },
      {
        h: "Doblar columna",
        p: [
          "Un bloque que está encima de otro ya tiene la altura extra que necesita. Si pones un bloque propio sobre otro propio (doblar), en el turno siguiente el de arriba puede subir al piso superior sin escalón. Es la base de maniobras como la Feedback.",
        ],
      },
      {
        h: "Subir dos pisos de una vez",
        p: [
          "Si en la misma línea hay un escalón en el primer piso y otro en el segundo, un bloque puede subir dos pisos en un solo movimiento. Por ejemplo, de A1 a E5 por la diagonal, apoyándose en B2 y en D4. El libro llama a esto escalera doble.",
        ],
      },
      {
        h: "Bajar",
        p: [
          "Bajar siempre está permitido, por grande que sea el desnivel. Pero piensa antes: al bajar pierdes toda la altura que habías ganado, y volver a subir puede costarte varios turnos.",
        ],
      },
    ],
    steps: {
      title: "Cómo preparar una subida",
      items: [
        "Elige la casilla del piso de arriba a la que quieres llegar.",
        "Busca una casilla interior en línea recta con ella y pon ahí un bloque (el escalón).",
        "Coloca el bloque que va a subir en la misma línea, del otro lado del escalón.",
        "Comprueba que el rival no puede dominar tu escalón antes de que subas.",
        "En tu siguiente turno, pasa por encima del escalón hasta el piso superior.",
      ],
    },
    faqs: [
      ["¿Por qué no puedo subir al segundo piso?", "Porque cada piso está dos alturas por encima del anterior y un bloque solo sube una altura por paso. Necesitas pasar por encima de un bloque que haga de escalón."],
      ["¿El escalón tiene que ser mío?", "No. Puedes apoyarte en un bloque del rival."],
      ["¿Puedo subirme a una torre de dos bloques?", "Desde el mismo nivel, no: serían dos alturas de golpe. Tendrías que estar ya encima de un bloque."],
    ],
    related: ["reglas/bloqueo-y-obstruccion", "estrategia/maniobra-feedback", "reglas/tablero-y-casillas", "estrategia/aperturas-xima"],
    cta: { label: "Bloqueo y obstrucción", slug: "reglas/bloqueo-y-obstruccion" },
    en: "en/climbing",
  },
  {
    slug: "reglas/bloqueo-y-obstruccion",
    theme: "reglas",
    nav: "Bloqueo y obstrucción",
    title: "Bloqueo y obstrucción en XIMA: cómo cortar caminos",
    description:
      "Qué es un bloqueo (superior o inferior) y una obstrucción (total o parcial) en XIMA, en qué se diferencian y cómo usarlos para frenar el ascenso del rival.",
    h1: "Bloqueo y obstrucción",
    intro:
      "En XIMA no solo se gana subiendo: también hay que impedir que el rival suba. Para eso se usan dos herramientas que el libro distingue con cuidado: el bloqueo y la obstrucción.",
    sections: [
      {
        h: "El bloqueo: cortar el paso entre pisos",
        p: [
          "Un bloqueo es una estructura de bloques que impide subir o bajar a otro bloque que está en un piso o nivel distinto. Hay dos tipos:",
        ],
        list: [
          "Bloqueo superior: el bloque que estorba está por encima del que quiere subir. Por ejemplo, un especial que quiere subir al tercer piso y encuentra un bloque rival en la casilla de llegada o en el camino, a una altura que no puede alcanzar.",
          "Bloqueo inferior: el que estorba está por debajo del que quiere bajar. Por ejemplo, un bloque que quiere bajar a dominar a otro, pero entre medias hay una columna que lo deja demasiado bajo para seguir.",
        ],
      },
      {
        h: "La obstrucción: cortar el paso en el mismo piso",
        p: [
          "Una obstrucción es una estructura que impide desplazarse dentro de un mismo piso. También hay dos tipos:",
        ],
        list: [
          "Total: el bloque no tiene forma de llegar a su destino en menos de tres movimientos, porque tendría que dar la vuelta al tablero.",
          "Parcial: puede llegar por otro camino, pero le cuesta más movimientos.",
        ],
      },
      {
        h: "Interno o externo",
        p: [
          "Tanto el bloqueo como la obstrucción pueden ser internos (el bloque que estorba está en el anillo interior) o externos (está en el anillo exterior).",
        ],
      },
      {
        h: "Cómo usarlos",
        p: [
          "Un buen bloqueo puede inutilizar varios bloques rivales con uno solo. Por eso el libro advierte que las diagonales superiores, aunque son el camino más rápido a la cima, también son las más fáciles de bloquear: si no aseguras tu escalera a tiempo, el rival puede «enterrar» con un movimiento toda una estructura que te costó varios turnos.",
          "Para atacar, busca rutas con más de una vía de subida. Para defender, ocupa las casillas interiores por las que el rival quiere pasar.",
        ],
      },
    ],
    faqs: [
      ["¿Qué diferencia hay entre bloqueo y obstrucción?", "El bloqueo corta el paso entre pisos distintos (subir o bajar). La obstrucción corta el paso dentro del mismo piso."],
      ["¿Una obstrucción captura bloques?", "No. Solo corta caminos. Capturar requiere dominar una columna."],
    ],
    related: ["reglas/subir-bloques", "estrategia/defensas-xima", "estrategia/medio-juego", "reglas/amenazas-al-especial"],
    cta: { label: "Defensas de XIMA", slug: "estrategia/defensas-xima" },
    legacy: ["reglas/bloqueo-superior-inferior", "reglas/obstruccion", "reglas/bloqueo-vs-obstruccion"],
  },
  {
    slug: "reglas/dominacion-y-captura",
    theme: "reglas",
    nav: "Dominación y captura",
    title: "Dominar y capturar en XIMA: reglas y ejemplos",
    description:
      "Cuándo un bloque domina a otro en XIMA, cuándo lo captura y qué son la captura sándwich, el aplastamiento y la dominación doble, compuesta o mixta.",
    h1: "Dominación y captura",
    intro:
      "En XIMA no hay que comerse las piezas del rival para ganar, pero dominar y capturar es la forma de frenarlo y de quitarle escalones. Esta guía explica exactamente cuándo pasa cada cosa.",
    sections: [
      {
        h: "Dominar",
        p: [
          "Un bloque domina cuando termina su movimiento encima de uno o varios bloques. Todos los que quedan debajo, sean del color que sean, no pueden moverse mientras siga tapándolos. En cuanto el bloque de arriba se va, los de abajo quedan liberados.",
          "Dominar también te da altura: un bloque encima de otro está más alto y puede subir más lejos en su siguiente movimiento.",
        ],
      },
      {
        h: "Capturar",
        p: [
          "Al llegar a una columna, se cuentan los bloques de cada color que hay en ella, contando el tuyo. Si ningún color tiene más bloques que el tuyo, se capturan todos los bloques de los colores que tengan menos que tú. Los bloques capturados salen del juego para siempre (salvo el especial, que se puede rescatar).",
        ],
        list: [
          "Un azul llega sobre un rojo: 1 contra 1. El rojo queda dominado, pero no se captura.",
          "Un azul llega sobre una columna con un rojo y otro azul: 2 azules contra 1 rojo. El rojo se captura.",
          "Un azul llega sobre dos rojos: 1 contra 2. Los rojos son mayoría, así que solo quedan dominados.",
        ],
        after: [
          "Ojo con la altura: para terminar encima de una columna de dos bloques hay que llegar desde más alto, por ejemplo bajando desde el piso de arriba o desde encima de otro bloque. Desde el mismo nivel solo se puede subir encima de un bloque.",
        ],
        figure: "dominacion-captura",
      },
      {
        h: "Tipos de captura",
        list: [
          "Sándwich: un bloque tuyo está dominado por un rival y otro bloque tuyo llega encima. El rival queda en minoría entre tus dos bloques y se captura.",
          "Aplastamiento: el mismo jugador vuelve a dominar una columna que ya dominaba, poniendo un segundo bloque encima del suyo.",
          "Mixta: las dos cosas a la vez en la misma columna.",
        ],
      },
      {
        h: "Tipos de dominación",
        list: [
          "Propia: dominas a uno o varios bloques de tu mismo color (por ejemplo, para doblar columna).",
          "Simple, doble, triple…: según cuántos bloques tengas debajo (1, 2, 3 o más).",
          "Compuesta: hay bloques de más de un jugador afectados en la misma columna.",
          "Mixta: en una misma columna se dan distintos tipos de dominación.",
          "Múltiple: cuando hablamos de varias dominaciones en distintas columnas a la vez.",
        ],
      },
      {
        h: "Consejos",
        list: [
          "En la apertura no salgas a cazar bloques: según el libro, dos tiempos valen a menudo más que un bloque.",
          "Dominar un escalón rival corta su subida sin necesidad de capturarlo.",
          "No apiles más de tres bloques propios en la misma casilla, y menos en el anillo interior: una torre así se puede dominar entera de golpe.",
        ],
      },
    ],
    faqs: [
      ["¿Dominar es lo mismo que capturar?", "No. Dominar inmoviliza; capturar elimina. Para capturar, tu color tiene que quedar en mayoría en la columna."],
      ["¿Se puede capturar al entrar un bloque?", "No. Al incorporar no puedes terminar encima de otro bloque."],
      ["¿Qué pasa con mis bloques dominados?", "Siguen en juego. Si el bloque de arriba se va, puedes volver a moverlos."],
    ],
    related: ["reglas/movimientos", "reglas/rescate", "reglas/fin-de-partida", "estrategia/medio-juego"],
    cta: { label: "El rescate del especial", slug: "reglas/rescate" },
    legacy: ["reglas/dominacion-tipos", "reglas/capturas-tipos"],
    en: "en/capturing",
  },
  {
    slug: "reglas/oposicion-especial",
    theme: "reglas",
    nav: "La oposición del especial",
    title: "La oposición del especial en XIMA",
    description:
      "Por qué un bloque especial no puede pasar sobre el otro en XIMA y cómo esa regla, la oposición, decide muchos finales cerca de la cima.",
    h1: "La oposición del especial",
    intro:
      "Dos bloques especiales nunca pueden estar en la misma columna. De esa regla sencilla nace una de las ideas más importantes de los finales de XIMA: la oposición.",
    sections: [
      {
        h: "La regla",
        p: [
          "Un bloque especial no puede subir ni pasar por encima de otro especial. Es decir, tu especial no puede entrar en una casilla donde esté el especial rival, ni cruzarla durante un movimiento. Los bloques comunes, en cambio, sí pueden dominar a un especial.",
        ],
      },
      {
        h: "Qué es la oposición",
        p: [
          "Se dice que los especiales están en oposición cuando están uno junto al otro, separados solo por el lado o por el vértice de una casilla. En esa situación, cada uno corta varias líneas del otro: las casillas que hay detrás de tu especial quedan fuera del alcance del especial rival en esa dirección.",
          "Esta situación tiene su mayor importancia en el final, cuando ambos especiales están en la tercera planta luchando por llegar a G7.",
        ],
      },
      {
        h: "Cómo se usa",
        p: [
          "Imagina un final en el que tu especial está en la tercera planta y quieres apoyarlo con un bloque común para subir a la cima. Si colocas el común en una casilla que el especial rival puede dominar, te lo quitará. Pero si lo colocas justo detrás de tu especial, en la línea que tu especial le tapa al rival, el especial contrario no podrá alcanzarlo: no puede pasar por encima del tuyo. Ese es el «punto ciego» que se busca en la maniobra dos contra uno.",
        ],
      },
      {
        h: "Consejos",
        list: [
          "Mantén tu especial en el anillo interior y en la misma banda que el especial contrario: así le cierras el paso.",
          "Usa la oposición para proteger tus bloques de apoyo.",
          "Recuerda que los comunes rivales sí pueden dominar a tu especial: la oposición solo te protege del otro especial.",
        ],
      },
    ],
    faqs: [
      ["¿Un especial puede dominar al otro especial?", "No. Un especial no puede subir encima del otro ni pasar por encima de él."],
      ["¿Un bloque común puede dominar a un especial?", "Sí. Y si su color queda en mayoría en esa columna, lo captura."],
    ],
    related: ["estrategia/finales-xima", "reglas/amenazas-al-especial", "reglas/bloques", "reglas/cima"],
    cta: { label: "Finales en XIMA", slug: "estrategia/finales-xima" },
  },
  {
    slug: "reglas/cima",
    theme: "reglas",
    nav: "La cima (G7)",
    title: "La cima de XIMA: la casilla G7 y cómo se gana",
    description:
      "La cima es G7, la única casilla del cuarto piso. Quién puede llegar a ella, cuándo da la victoria y cómo se anota la llegada en una partida de XIMA.",
    h1: "La cima (G7)",
    intro:
      "Toda la partida gira en torno a una sola casilla: G7, la cima de la pirámide. Quien lleva ahí su bloque especial con una jugada legal gana al instante.",
    sections: [
      {
        h: "Dónde está",
        p: [
          "G7 es el centro exacto del tablero y la única casilla del cuarto piso. Desde el tercer piso se llega a ella con un apoyo, igual que a cualquier otro piso: hace falta un bloque que sirva de escalón o estar ya encima de otro bloque.",
        ],
      },
      {
        h: "Quién puede terminar en la cima",
        list: [
          "Tu bloque especial: si llega con una jugada legal, ganas la partida.",
          "Uno de tus bloques comunes, solo si tu especial está capturado: es el rescate.",
          "Cualquier bloque puede pasar por encima de G7 durante un movimiento sin detenerse en ella.",
        ],
      },
      {
        h: "Cómo llegar",
        p: [
          "El libro recomienda que, si tu especial llega libre a la tercera planta, se coloque en las líneas centrales o en las diagonales exteriores, alineado con G7. Y que lleve un bloque común cerca: según el libro, dos bloques siempre ganan a uno, aunque ese uno sea un especial.",
        ],
      },
      {
        h: "Cómo se anota",
        p: [
          "En la notación de XIMA, la llegada a la cima se puede escribir de varias formas: G7, Xima, Cima, 4.º piso, (*), (x+), 1-0, 77 o Gana. Por ejemplo, «26. G7» o «26. Cima».",
        ],
      },
    ],
    faqs: [
      ["¿Qué pasa si un bloque común llega a la cima?", "Solo puede hacerlo si tu especial está capturado, y entonces sirve para rescatarlo, no para ganar."],
      ["¿Se puede pasar por encima de la cima?", "Sí. Cualquier bloque puede cruzar G7 en mitad de un movimiento."],
    ],
    related: ["reglas/rescate", "estrategia/finales-xima", "reglas/oposicion-especial", "sistema-de-anotacion"],
    cta: { label: "Finales en XIMA", slug: "estrategia/finales-xima" },
    legacy: ["reglas/objetivo", "reglas/bloque-comun-g7"],
  },
  {
    slug: "reglas/rescate",
    theme: "reglas",
    nav: "El rescate del especial",
    title: "Rescatar el bloque especial en XIMA",
    description:
      "Si te capturan el bloque especial en XIMA no pierdes: lleva un bloque común a la cima y recupéralo. Así funciona el rescate paso a paso.",
    h1: "El rescate del especial",
    intro:
      "Perder el bloque especial no es perder la partida. XIMA permite rescatarlo, y conocer bien esta regla puede darle la vuelta a una posición que parecía perdida.",
    sections: [
      {
        h: "Cómo funciona",
        p: [
          "Si te capturan el especial, puedes llevar uno de tus bloques comunes a la cima (G7). Al llegar, ese común se retira inmediatamente de la cima y a cambio recuperas tu especial, que vuelve a estar fuera del tablero, listo para incorporarlo cuando quieras.",
          "Es la única situación en la que un bloque común puede terminar su movimiento en la cima. Llegar con un común no gana la partida: solo te devuelve el especial.",
        ],
      },
      {
        h: "Cuándo conviene rescatar",
        p: [
          "El rescate cuesta tiempo: llevar un común a la cima es tan difícil como llevar el especial. Por eso compensa sobre todo cuando ya tienes un común bien colocado en la tercera planta.",
          "Recuerda también que, una vez rescatado, el especial vuelve fuera y tienes que meterlo de nuevo por el borde. En medio juego o en el final, reincorporarlo puede ser muy lento y peligroso.",
        ],
      },
      {
        h: "La amenaza de rescate",
        p: [
          "El libro cita como última defensa, la más desesperada, amenazar la cima con un bloque común: si el rival captura tu especial, lo rescatarías al instante. A veces esa sola amenaza hace que el rival se lo piense dos veces.",
          "Y al revés: por eso muchas veces conviene dominar el especial rival en lugar de capturarlo.",
        ],
      },
    ],
    steps: {
      title: "Rescate paso a paso",
      items: [
        "Comprueba que tu especial está capturado (no solo dominado).",
        "Elige un bloque común que pueda llegar a la cima con un escalón o desde lo alto de una columna.",
        "Llévalo a G7 con una jugada legal.",
        "El común se retira de la cima y recuperas el especial fuera del tablero.",
        "Vuelve a incorporar el especial cuando tenga un buen camino.",
      ],
    },
    faqs: [
      ["¿El rescate gana la partida?", "No. Solo te devuelve el bloque especial."],
      ["¿Puedo rescatar si mi especial está dominado pero no capturado?", "No. Un especial dominado sigue en el tablero; para liberarlo tienes que conseguir que se vaya el bloque de encima o capturarlo tú."],
      ["¿Cuántas veces se puede rescatar?", "Las reglas no ponen límite: cada vez que te capturen el especial puedes intentar rescatarlo."],
    ],
    related: ["reglas/cima", "reglas/dominacion-y-captura", "reglas/amenazas-al-especial", "reglas/fin-de-partida"],
    cta: { label: "Amenazas al especial", slug: "reglas/amenazas-al-especial" },
    legacy: ["reglas/rescate-avanzado"],
  },
  {
    slug: "reglas/fin-de-partida",
    theme: "reglas",
    nav: "Cómo termina la partida",
    title: "Cómo se gana en XIMA: cima, ahogado y sin recurso",
    description:
      "Todas las formas de ganar o perder una partida de XIMA: llegar a la cima, el ahogado, quedarse sin recurso, abandonar o agotar el tiempo.",
    h1: "Cómo termina la partida",
    intro:
      "La forma normal de ganar es llevar el especial a la cima, pero hay otras maneras de terminar una partida. Conocerlas evita sorpresas, sobre todo con la regla del ahogado.",
    sections: [
      {
        h: "1. Llegar a la cima",
        p: ["Gana el primer jugador que lleva su bloque especial a G7 con una jugada legal. Es el final más habitual."],
      },
      {
        h: "2. El ahogado: ganar sin poder mover",
        p: [
          "Si un jugador, en su turno, no tiene ningún bloque fuera del tablero para incorporar y todos sus bloques del tablero están dominados, está ahogado y gana la partida.",
          "Las dos condiciones son necesarias. Si todavía te queda un bloque fuera, puedes incorporarlo y no estás ahogado, aunque todos tus bloques del tablero estén tapados.",
          "El libro explica el porqué: es una regla de honor y esperanza que siempre da al jugador acorralado la oportunidad de defenderse. En la práctica obliga al que va ganando a no tapar todos los bloques del rival sin pensar.",
        ],
      },
      {
        h: "3. Sin recurso: perder por quedarse sin bloques",
        p: [
          "Si un jugador, en su turno, no tiene ningún bloque ni dentro ni fuera del tablero, pierde. Es lo que ocurre cuando le han capturado todos sus bloques.",
          "No hay que confundirlo con el ahogado: en el ahogado todavía tienes bloques (dominados) y ganas; sin recurso no tienes ninguno y pierdes.",
        ],
      },
      {
        h: "4. Abandono y tiempo",
        p: [
          "Una partida también termina si un jugador se rinde o se le acaba el tiempo. En la web, cada partida tiene un tiempo por turno (1, 2, 5 o 10 minutos).",
          "El libro recuerda que en las partidas en las que se registran estadísticas conviene jugar hasta el final, porque una derrota no define el nivel de nadie y la puntuación tiene en cuenta cómo se jugó.",
        ],
      },
      {
        h: "Con más de dos jugadores",
        p: [
          "Las mismas reglas valen para 3 o 4 jugadores. En la notación del libro, «0-1-0-0» significa que ganó el segundo en salir y perdieron el primero, el tercero y el cuarto. En juego por equipos, «0-1-0-1» indica que ganaron el segundo y el cuarto.",
        ],
      },
    ],
    faqs: [
      ["¿Qué es el ahogado en XIMA?", "Cuando un jugador, en su turno, no tiene bloques fuera para incorporar y todos sus bloques del tablero están dominados. Ese jugador gana."],
      ["¿Si todos mis bloques están dominados pero tengo uno fuera, estoy ahogado?", "No. Puedes incorporar el bloque que tienes fuera, así que la partida sigue."],
      ["¿Qué pasa si me capturan todos los bloques?", "Pierdes la partida: es la situación de sin recurso."],
      ["¿Puede terminar en empate?", "No. Si la partida se estanca se aplica el incremento de material."],
    ],
    related: ["reglas/incremento-de-material", "reglas/dominacion-y-captura", "reglas/cima", "reglas"],
    cta: { label: "Incremento de material", slug: "reglas/incremento-de-material" },
    legacy: ["reglas/ahogado", "reglas/sin-recurso"],
  },
  {
    slug: "reglas/incremento-de-material",
    theme: "reglas",
    nav: "Sin empates: incremento",
    title: "Incremento de material: por qué XIMA no tiene empates",
    description:
      "En XIMA no hay tablas: si la partida se estanca, cada jugador recibe 3 bloques comunes más. Cuándo se aplica: posición muerta, repetición, acuerdo o 50 jugadas.",
    h1: "Incremento de material",
    intro:
      "En el ajedrez o el go una partida puede acabar en tablas. En XIMA, no: el juego está pensado para que siempre haya un ganador. Cuando una partida se atasca se aplica el incremento de material.",
    sections: [
      {
        h: "La regla",
        p: [
          "Ante cualquier situación que lleve a un empate o a un estancamiento, no se piden tablas: se pide incremento de material. Cada jugador recibe tres bloques comunes extra, además de los diez iniciales, y la partida sigue con nuevas posibilidades para todos.",
        ],
      },
      {
        h: "Cuándo se aplica",
        p: ["Según el libro, se recurre al incremento cuando:"],
        list: [
          "Se llega a una posición muerta: ningún jugador puede llevar su especial a la cima con una serie de jugadas legales (siempre que la jugada que creó esa posición fuera legal).",
          "Todos los jugadores lo acuerdan. En una competición, el árbitro valora si procede.",
          "Una misma posición ha aparecido, o está a punto de aparecer, al menos cuatro veces.",
          "En las últimas 50 jugadas de cada jugador no ha habido ninguna captura ni nadie ha subido de piso.",
        ],
      },
      {
        h: "La regla de la repetición",
        p: [
          "Relacionada con lo anterior: no se puede mover por tercera vez consecutiva a la misma posición ni repetir por tercera vez la misma secuencia de movimientos. Así se evita que un jugador alargue la partida yendo y viniendo con el mismo bloque.",
        ],
      },
      {
        h: "Qué cambia con el incremento",
        p: [
          "Tres bloques nuevos por jugador son tres posibles escalones nuevos. Lo que antes estaba cerrado puede abrirse, y el juego vuelve a decidirse sobre el tablero. Como el incremento es igual para todos, nadie sale favorecido de entrada.",
        ],
      },
    ],
    faqs: [
      ["¿XIMA tiene tablas?", "No. En lugar de empatar se aplica el incremento de material."],
      ["¿Cuántos bloques se añaden?", "Tres bloques comunes para cada jugador."],
      ["¿Qué es una posición muerta?", "Una posición en la que ningún especial puede llegar ya a la cima con jugadas legales."],
    ],
    related: ["reglas/fin-de-partida", "reglas", "reglas/bloqueo-y-obstruccion"],
    cta: { label: "Cómo termina la partida", slug: "reglas/fin-de-partida" },
    legacy: ["reglas/incremento-material-avanzado", "reglas/posicion-muerta"],
  },
  {
    slug: "reglas/dados",
    theme: "reglas",
    nav: "Los dados",
    title: "Los dados en XIMA: cómo se mueve en Modo Azar",
    description:
      "Cómo funcionan los dos dados de XIMA: cada dado es un movimiento, se pueden usar en cualquier orden y con el mismo bloque, y la entrada cuenta como un paso.",
    h1: "Los dados",
    intro:
      "En los modos con azar se lanzan dos dados y sus números marcan cuántos pasos dan tus bloques. Esta guía explica cómo se usan exactamente.",
    sections: [
      {
        h: "Dos dados, dos movimientos",
        p: [
          "Cada dado es un movimiento independiente. Si sacas un 5 y un 3, puedes mover un bloque 5 pasos y otro 3, o el mismo bloque 5 pasos en una dirección y luego 3 en otra. Puedes usarlos en el orden que prefieras.",
          "El libro explica por qué son dos: con la suma máxima, 12, un bloque puede llegar a cualquier parte del tablero, igual que el jugador de Ciencia que mueve libremente. Y poder usar cada dado por separado (incluso cambiando de dirección con el mismo bloque) le da al bando del azar una ventaja que equilibra el juego.",
        ],
      },
      {
        h: "Pasos exactos",
        p: [
          "Con dados, el bloque tiene que avanzar exactamente los pasos que marca el dado, en línea recta. Todas las demás reglas siguen igual: la altura, el borde del tablero, la oposición de los especiales y la cima.",
        ],
      },
      {
        h: "Incorporar con dados",
        p: [
          "Al meter un bloque nuevo, la casilla del borde por la que entra cuenta como el primer paso. Con un 4, entras por el borde y avanzas tres casillas más.",
        ],
      },
      {
        h: "Cómo se anota",
        p: [
          "Se escriben los números de los dados seguidos de una barra antes de la jugada. Con un dado: «4/-A4». Con dos dados: «64/-F2-H4» (con el 6 y el 4 se incorporan dos bloques, en F2 y en H4).",
        ],
      },
      {
        h: "En qué modos hay dados",
        list: [
          "Modo Azar: los dos jugadores lanzan los dados en cada turno.",
          "Modo Cienzar: en cada turno eliges si juegas libre o lanzas los dados.",
          "Ciencia V/S Azar: solo lanza dados el bando que tiene el rol de Azar.",
          "Modo Ciencia: no hay dados.",
        ],
      },
    ],
    faqs: [
      ["¿Cuántos dados se usan en XIMA?", "Dos. Cada uno es un movimiento."],
      ["¿Puedo mover el mismo bloque con los dos dados?", "Sí, y puedes cambiar de dirección entre un dado y otro."],
      ["¿Se pueden sumar los dados?", "Puedes mover el mismo bloque con los dos, que en la práctica suma los pasos, pero cada dado se juega como un movimiento en línea recta."],
    ],
    related: ["azar", "cienzar", "modos/ciencia-vs-azar", "sistema-de-anotacion"],
    cta: { label: "Modo Azar", slug: "azar" },
    legacy: ["tutoriales/lanzar-dados", "azar/dados", "solucion/dados-no-aparecen"],
  },
];
